import { useComposablePage } from '@bnnvara/composable';
import React from 'react';

import withBrandedComposablePage from '../../../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../../../layouts/ComposablePageLayout';
import ArticleOverviewPageQuery from './ArticleOverviewPage.gql';
import pageData from './ArticleOverviewPage.json';

const ArticleOverviewPage = () => {
  const { render } = useComposablePage();
  const content = render(pageData);

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: ArticleOverviewPageQuery,
})(ArticleOverviewPage);
